import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=7af05eea&scoped=true"
import script from "./Detail.vue?vue&type=script&lang=ts"
export * from "./Detail.vue?vue&type=script&lang=ts"
import style0 from "./Detail.vue?vue&type=style&index=0&id=7af05eea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af05eea",
  null
  
)

export default component.exports